
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4289|8877)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
